export default __webpack_public_path__ + "static/media/focoanimado.5d74f622.gif";